import React from 'react';
import { ProcedureCodeEditTemplate } from 'themes/application/procedure-code/pages';
import { observer } from 'mobx-react';
import { ProcedureCodeEditViewStore } from 'application/procedure-code/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProcedureCodeEditViewStore(rootStore), 'procedureCodeEditViewStore')
@observer
class ProcedureCodeEdit extends React.Component {
    render() {
        return <ProcedureCodeEditTemplate {...this.props} />
    }
}

export default ProcedureCodeEdit;